import $ from "jquery";

const actionfilter = () => {
  const init = () => {
    executefilter();
  };

  const executefilter = () => {
    const el = {
      selectedCategory: ".js-remove-item-tag",
      input: ".js-filter-checkbox",
      clearButton: ".js-button-filter-clear",
    };

    $(el.clearButton).hide();

    if ($(el.input).length === 0) return;

    const handleSubmit = (e) => {
      e.preventDefault();
      let data = [];
      $(`${el.input}:checked`).each(function () {
        data.push($(this).val());
      });

      const isMobileParam = window.screen.width < 600 ? "&is_opened_popup" : "";
      const baseUrl = `${$(".js-box-filter").data("url")}`;
      const loadingState = $("#applyFilter .loading");
      loadingState.show();

      let _url = new URL(window.location.href);
      const _urlSearch = _url.search
        .replace("?", "")
        .replaceAll(/category[^&]*/g, "")
        .replaceAll(/product-page[^&]*/g, "");

      const _params = _urlSearch.split("&");
      let _paramsList = _params.filter((p) => p !== "");
      if (data.length > 0) {
        _paramsList.push(`category=${data}${isMobileParam}`);
      }
      const params = _paramsList.join("&");

      const url = `${baseUrl}?${params}`;

      fetch(url)
        .then((res) => res.text())
        .then((res) => {
          const productSection = $(res).find("#js-section-products > *");
          const colLeft = $(res).find("#js-col-left > *");
          $("#js-section-products").html(productSection);
          $("#js-col-left").html(colLeft);
          history.replaceState(null, null, url);
          const urlParams = new URLSearchParams(window.location.search);
          const categoryParam = urlParams.get("category");

          if (
            categoryParam !== null &&
            categoryParam !== "" &&
            window.screen.width < 600
          ) {
            $(el.clearButton).show();
          } else {
            $(el.clearButton).hide();
          }
          loadingState.hide();
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error("Error fetching or updating HTML:", error);
        });
    };

    const handleClearButton = (e) => {
      e.preventDefault();

      const isMobileParam = window.screen.width < 600 ? "&is_opened_popup" : "";
      const url = `${$(".js-box-filter").data("url")}?${isMobileParam}`;

      const loadingState = $("#applyFilter .loading");
      loadingState.show();
      fetch(url)
        .then((res) => res.text())
        .then((res) => {
          const productSection = $(res).find("#js-section-products > *");
          const colLeft = $(res).find("#js-col-left > *");
          $("#js-section-products").html(productSection);
          $("#js-col-left").html(colLeft);
          history.replaceState(null, null, url);

          const urlParams = new URLSearchParams(window.location.search);

          const categoryParamExist = urlParams.has("category");

          if (categoryParamExist) {
            $(el.clearButton).show();
          } else {
            $(el.clearButton).hide();
          }
          loadingState.show();
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error("Error fetching or updating HTML:", error);
        });
    };

    $(document).on("click", el.clearButton, handleClearButton);

    $(document).on("click", el.selectedCategory, function () {
      const value = $(this).data("value");
      $(`${el.input}[value="${value}"]`).trigger("click");
    });
    $(document).on("change", el.input, handleSubmit);
  };

  init();
};
try {
  actionfilter();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
